module.exports = __webpack_public_path__ + "static/video_banner1-5452e43a8db30f0363b36a9819812d93.jpg";